var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{attrs:{"to":"/member/manage","flat":"","color":"primary"}},[_c('v-icon',{staticClass:"fa fa-arrow-left",attrs:{"left":"","small":""}}),_c('span',[_vm._v("Back")])],1),_c('v-layout',{attrs:{"justify-center":""}},[_c('Detail')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }